var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalLifestyleBro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447.23 141.67q-4.39-2.8-8.71-5.73c-31-21-176-116.37-237.08-107.62C132.81 38.14-12.78 255.2 24.31 319.51s222.57 176 271.72 158.1S476.87 263.24 485.22 215c7.12-41.18-27.67-66.74-37.99-73.33z",
    fill: "#92e3a9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M447.23 141.67q-4.39-2.8-8.71-5.73c-31-21-176-116.37-237.08-107.62C132.81 38.14-12.78 255.2 24.31 319.51s222.57 176 271.72 158.1S476.87 263.24 485.22 215c7.12-41.18-27.67-66.74-37.99-73.33z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.67 122.28a20 20 0 01-20-20 20 20 0 0120-20 20 20 0 0120 20 20 20 0 01-20 20z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.21 101.77a10.79 10.79 0 00-21.56-.2v.47a10.65 10.65 0 001.55 5.53l-2 5.74 6-1.9a10.79 10.79 0 0016-9.37 2.44 2.44 0 00.01-.27zM122.43 111a9.09 9.09 0 01-5-1.49l-3.43 1.15 1.13-3.34a8.9 8.9 0 01-1.73-5.28 8.3 8.3 0 010-.87 9.07 9.07 0 0118.06.17v.7a9 9 0 01-9.03 8.96z",
    fill: "#92e3a9",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.38 104.2c-.27-.13-1.57-.77-1.81-.85s-.42-.13-.6.13-.69.85-.84 1-.3.2-.57.07a7.09 7.09 0 01-2.13-1.3 7.89 7.89 0 01-1.47-1.82c-.15-.26 0-.4.12-.53s.26-.31.4-.46l.09-.13a2.16 2.16 0 00.17-.31.49.49 0 000-.46c-.07-.13-.6-1.42-.82-2s-.44-.43-.6-.43h-.5a1 1 0 00-.71.33 2.94 2.94 0 00-.92 2.19 3.3 3.3 0 00.13.89 5.92 5.92 0 001 1.82 10.91 10.91 0 004.51 4c2.7 1 2.7.69 3.18.65a2.6 2.6 0 001.78-1.25 2.08 2.08 0 00.16-1.25c-.13-.09-.31-.16-.57-.29z",
    fill: "#92e3a9",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M415.36 92.56a20 20 0 01-20-20 20 20 0 0120-20 20 20 0 0120 20 20 20 0 01-20 20z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M412.19 84.64h4.88V72.43h3.4l.36-4.09h-3.76V66c0-1 .19-1.35 1.12-1.35h2.64v-4.23h-3.38c-3.62 0-5.26 1.6-5.26 4.66v3.26h-2.54v4.14h2.54z",
    fill: "#92e3a9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.83 418.77a20 20 0 01-20-20 20 20 0 0120-20 20 20 0 0120 20 20 20 0 01-20 20z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.16 405.44a12.45 12.45 0 0019.16-11.06 8.88 8.88 0 002.19-2.26 9.21 9.21 0 01-2.52.69 4.41 4.41 0 001.93-2.43 9 9 0 01-2.78 1.07 4.38 4.38 0 00-7.47 4 12.41 12.41 0 01-9-4.58 4.38 4.38 0 001.33 5.84 4.28 4.28 0 01-2-.55 4.37 4.37 0 003.51 4.35 4.38 4.38 0 01-2 .08 4.4 4.4 0 004.09 3 8.78 8.78 0 01-6.44 1.85z",
    fill: "#92e3a9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.61 148.45a30.4 30.4 0 00-15.77 4.33 59.45 59.45 0 00-5.65 4.16 3.66 3.66 0 01-3.5.84 3.21 3.21 0 01-1.81-4.72 7.68 7.68 0 011.39-1.57 37.37 37.37 0 0121.4-9.47c11.19-1.13 20.91 2.28 29.35 9.6a4 4 0 011.68 2.75 3.26 3.26 0 01-5.19 3c-.66-.45-1.24-1-1.86-1.54a31.08 31.08 0 00-19.2-7.3z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.09 166.3a3.59 3.59 0 01-2.57-1.11 20 20 0 00-26.75-.94c-.56.47-1.1 1-1.69 1.39a3.29 3.29 0 01-4.45-.48 3.24 3.24 0 01.11-4.4 24.7 24.7 0 019.5-6.14 26.24 26.24 0 0120.72.86 25.21 25.21 0 017.4 5.16 3.26 3.26 0 01.7 3.7 3.15 3.15 0 01-2.97 1.96z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.49 164a15.54 15.54 0 0111.51 5 3.29 3.29 0 01.14 4.52 3.37 3.37 0 01-4.63.3 17.49 17.49 0 00-3.66-2.48c-3.49-1.41-6.67-.62-9.44 1.87a4 4 0 01-3.44 1.33 3.22 3.22 0 01-2-5.18 13.66 13.66 0 015.61-4.11 15.56 15.56 0 015.91-1.25zM124.63 183.51a3.92 3.92 0 01-4-4 4 4 0 013.94-4 4 4 0 11.09 7.95z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.88 212.5a14.61 14.61 0 00-14.61 14.61c0 8.07 14.61 20.93 14.61 20.93s14.61-12.86 14.61-20.93a14.61 14.61 0 00-14.61-14.61zm0 19.84a5.23 5.23 0 115.23-5.23 5.23 5.23 0 01-5.23 5.23zM142.57 343.87A14.61 14.61 0 00128 358.48c0 8.07 14.61 20.93 14.61 20.93s14.61-12.86 14.61-20.93a14.61 14.61 0 00-14.65-14.61zm0 19.84a5.23 5.23 0 115.23-5.23 5.23 5.23 0 01-5.23 5.23z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88 248v10.9a7.37 7.37 0 01-7.37 7.37H39.1a7.91 7.91 0 00-7.91 7.92v19.48a7.92 7.92 0 007.91 7.92h34.17a7.75 7.75 0 017.73 7.75v14a7.75 7.75 0 01-7.75 7.75h-8.7a6.29 6.29 0 00-6.29 6.29h0a6.29 6.29 0 006.29 6.29h50.1a5.54 5.54 0 015.54 5.53v23.38a6.41 6.41 0 006.41 6.41h15.84",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 335.38,
    cy: 417.38,
    r: 14.84,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.19 410.58h4.95v14.23h-4.95zM336.91 410.58h4.95v14.23h-4.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.48,
    cy: 417.38,
    r: 14.84,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M364.06 410.58h4.95v14.23h-4.95zM382.88 417.69l-10.74-6.6v13.21l10.74-6.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.53,
    cy: 417.38,
    r: 14.84,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.96 424.8h-4.95v-14.23h4.95zM286.14 417.69l10.73-6.6v13.21l-10.73-6.61z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.58,
    y: 344.47,
    width: 43.38,
    height: 38.57,
    rx: 3.31,
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.26,
    cy: 363.76,
    r: 9.87,
    transform: "rotate(-35.9 414.26 363.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16 350.8a3.94 3.94 0 10-3.93 3.93 3.93 3.93 0 003.93-3.93z",
    fill: "#263238"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.53,
    y: 319.47,
    width: 43.38,
    height: 38.57,
    rx: 3.31,
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M350.85 339.06l-21.01-12.13v24.26l21.01-12.13z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M432.89 299.44h-56.46l-8.61-37.24h56.46l8.61 37.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M378.93 253.76h54.04v42.4h-54.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M376.51 256.42h54.04v42.4h-54.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M432.89 299.44l2.02-41.56h-23.27l-3.15 2.18h-28.35l-3.71 39.38h56.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M417.22 280.09l-9.51-14.47-9.52 14.47h5.28v10.74h8.48v-10.74h5.27z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174 277.32h-36.79a3.31 3.31 0 00-3.31 3.31v31.94a3.31 3.31 0 003.31 3.31h14.32l4.05 7 4.06-7H174a3.31 3.31 0 003.31-3.31v-31.94a3.31 3.31 0 00-3.31-3.31z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19 296.85l-1.57 1.58-10 10L144 296.85a7.11 7.11 0 015-12.12 7 7 0 015 2.09l1.59 1.58 1.56-1.58a7.1 7.1 0 0110 10z",
    fill: "#92e3a9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.45 58.8h144.49a7 7 0 017 7v89.89a4.76 4.76 0 01-4.76 4.76h-149a4.76 4.76 0 01-4.76-4.76v-89.9a7 7 0 017.03-6.99z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93 70.84v-5a7 7 0 00-7-7H178.45a7 7 0 00-7 7v5z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.84 65.55a2.93 2.93 0 10-2.92 2.92 2.93 2.93 0 002.92-2.92z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.88 65.55a2.93 2.93 0 10-2.88 2.92 2.93 2.93 0 002.88-2.92z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.99,
    cy: 65.55,
    r: 2.92,
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M388.28 115.91a13.58 13.58 0 00-1.69.12 19.65 19.65 0 00-38.4-3.09 14.74 14.74 0 001.68 29.39h38.41a13.21 13.21 0 100-26.42z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M363.42 153.19l-5.47-9.48-5.47 9.48h2.78v7.6h5.38v-7.6h2.78zM369.8 151.31l5.47 9.48 5.48-9.48h-2.79v-7.6h-5.37v7.6h-2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5,5",
    d: "M366.5 169.71v44.83"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M287.41 135s6.66.38 8.75-2.85-3-7.42-2.47-9.51 10.27-1.71 7.6-12.74-12-14.45-16.92-14.07-9.7 2.47-14.08 1.71-19.39-8.56-34 .76-8.56 27-7.61 30.62-15.4 2.85-17.68 16.73 7.79 24.54 31 23.21 23.58-10.46 22.44-18.26 4.18-25.11 9.89-26.44 7.61 4.57 8.56 7 3.19 4.56 4.52 3.84z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38 184.11s8 1.21 10.46 6.57 7.79 46.7 7.79 46.7l-18.73 7.3s-.25-7.78-2.92-26.27-.73-35.27 3.4-34.3z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31 274.86a53.92 53.92 0 0018.47 3.53c10 0 6.85-10 6.64-10.79s-18.89 3.74-25.11 7.26z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19 262.26s17.25 30.92 27.32 41.71 13.67 21.21 13.67 21.21l5.39 8.63s-11.51 20.85-11.51 21.93-29.12 49.26-30.56 50.34-12.22 2.52-13.3 6.11 2.15 11.51 2.87 12.95 1.08 12.58 4.32 16.54 5 4.31 6.11 2.15 1.44-21.57 5.39-28 49.62-44.23 57.53-55 12.48-53.65 10.79-67.6-5-21.93-5-21.93-34.55-21.98-73.02-9.04z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.08 391.14c-5 8.14-9.06 14.55-9.58 14.94-1.44 1.08-12.22 2.52-13.3 6.11s2.15 11.51 2.87 12.95 1.08 12.58 4.32 16.54 5 4.31 6.11 2.15 1.44-21.57 5.39-28c1.41-2.3 8.09-8.56 16.47-16.15a23.45 23.45 0 01-12.28-8.54z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.86 415.43a19.5 19.5 0 01-1.67-8.8c-3.3 1-11.08 2.53-12 5.56-1.08 3.6 2.15 11.51 2.87 12.95s1.08 12.58 4.32 16.54 5 4.31 6.11 2.15 1.44-21.57 5.39-28z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.91 269.09c14.74 10.79 39.91 61.48 39.19 65.44s-17.62 20.13-29.49 26.61-55.37 36.31-57.88 38.11-11.51 16.9-12.95 20.13-1.44 6.83-3.23 10.79-7.2-1.8-9.35-9-.72-25.53.36-28.4 18-2.52 18-2.52 29.44-32.35 35.21-38.1S248 339.56 248 339.56s-19.78-20.85-30.56-34.51-16.54-38.84-16.54-38.84 27-3.95 37.39-3.59",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76 292.27c7.48 12.42 20.93 36.5 18.57 45.47-3.23 12.31-40.16 31.74-40.16 31.74M259 284.62s1 1.61 2.69 4.28",
    fill: "none",
    stroke: "#d1d1d1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.94 373.42c-8.07 8.79-15.41 16.84-15.41 16.84s-16.89-.36-18 2.52-2.53 21.22-.33 28.4 7.55 12.94 9.35 9 1.79-7.55 3.23-10.79 10.43-18.33 12.95-20.13c1-.73 8.75-6.05 18.38-12.56a33.51 33.51 0 01-10.17-13.28z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 401.05c-1.08-1.08-3.59-.72-3.59-.72s.21-4.23.47-10.08c-4.3 0-15.42.21-16.29 2.53-1.08 2.87-2.52 21.21-.36 28.4s7.55 12.94 9.35 9 1.79-7.55 3.23-10.79a157.51 157.51 0 019.41-15.75c-.79-.96-1.7-2.05-2.22-2.59zM355.6 251.13s-1.61 6.24-12.32 4.46c-3.08-.51-13 4.82-29.09 6.6-7 .78-15.23.34-18.06.34a7.26 7.26 0 01-5.2-1.65c-.95-.83-6.5-16.67-6.5-16.67l12.88-4.49 3.54 6.27s.15 1.19 13 3.53c13 2.38 33.58-3.42 36.3-4.48s5.57 4.79 5.45 6.09z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17 240.79s21.89-8 22.62-6.81 1 12.16 1 12.16-2.67 2.44-9.73 4.14a95.63 95.63 0 01-12.65 2.19z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M362.57 219.89l-17.95 28.12 8.68 7.78 18.55-27.82-9.28-8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62 248l7.18-8.67 2.1-.6c2.09-.6 6-.6 7.18-1.5s0-2.69-1.5-2.39a86.66 86.66 0 01-8.67.3c-1.2 0-9 6.88-9 6.88l-1.5 8.68M368 234.25s3 1.8.3 3.29-2.52-.18-2.52-.18zM364.2 240.08a1.68 1.68 0 01.47 2.12c-.7 1.19-2.83 1-2.83 1zM361.6 244.33a1.7 1.7 0 01.47 2.13c-.7 1.18-2.83.94-2.83.94zM359 248a1.7 1.7 0 01.47 2.13c-.7 1.18-2.83.95-2.83.95zM281.38 234.22s2 11.25 6.65 19.28 5.93 20 5.93 20l.59 11.18-15.29-8.24s.42-28.62-1-33.73-2.68-17.28-.49-16.06 3.61 7.57 3.61 7.57z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.14 179s2.67.73 4.38 5.35 3.89 34.3 3.65 38.92.48 16.3.73 21.41 4.62 34.55 4.62 34.55a92.27 92.27 0 00-34.3-11c-20.44-2.43-34.06-.73-35.76-.24s11.19-25.55 11.92-45.25-2.19-45 8.51-46 18.73-1.7 21.65-1.95 14.6 4.21 14.6 4.21z",
    fill: "#d1d1d1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M271.17 221.82l-21.41 9.97M265.33 227.41l-12.9 6.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 147.13s-1.7 12.33-4.84 19.58-11.84 8.7-10.88 9.91 14.27 20.31 18.86 20.79 14.74-13 15-15.47-1.45-.49-2.42-6 3.62-13.3 3.62-13.3S256.2 151 256 147.13z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47 120.7a10 10 0 00-10.46-1c-5.9 2.85-6.09 13.12-9.89 18.26s-7.8 3-7.8 3-6.09-7.61-6.85 2.66 6.09 9.13 7.61 9.13.76-1.14.76-1.14 2.66 6.47 4.56 8 17.11 6.8 21.11 7c6.47.38 6.09-5.89 6.09-5.89l3.23-13.31s5.71-4.19 4.57-5.9-6.47-3-8-6.66.6-10.54-4.93-14.15z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.67 146.37s3.8 4.19 8 4.38",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47 135.63c0 1.42-.47 2.57-1.05 2.57s-1.05-1.15-1.05-2.57.47-2.57 1.05-2.57 1.05 1.15 1.05 2.57z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71 129.64s3.42-3.61 6.28-1.14",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89 191.44s-.42 28.64-1 37.15-7.06 27.6-10.17 31.75-4.56 7.26-12.87 9.75-30.5 4.77-30.5 4.77 20.13-26.56 23.24-34.24 4.57-25.94 4.57-25.94l-33.62-2.49s18.88-17.43 23.24-24.07 10-11.41 20.13-12.66 15.37 1.16 15.37 1.16z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23 173.3s-2.13 8-2.13 13.07a38.85 38.85 0 01-.53 7.47s-4.27-.53-5.87 0-7.47 1.6-7.47 1.6 2.13-19.74 6.93-22.94 9.07.8 9.07.8z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25 196.78s2.94 30.14 5.13 37.44a124.89 124.89 0 003.9-14.11c1.21-6.32-1.95-21.41-2.68-25.54s-5.6-4.83-6.35 2.21z",
    fill: "#92e3a9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67 175.9l3 12.07 1.6 8.81 8.27 2.4s.74-12.16-3-17.49-8.54-7.69-9.87-5.79zM239.6 235.23s-6 8.51-10.16 11-15.57 12.86-15.57 12.86 7.47 1.25 9.75 3.74 1.87 3.73 1.87 3.73 5-2.9 8.93-11.62 5.18-19.71 5.18-19.71zM183.57 206.59s-6.22 8.3-6.64 9.13 1.46 1.25 2.7 1 12.24 1.45 12.24 1.45L203.7 213s-.41-2.69-8.09-5.18-10.61-2.68-12.04-1.23z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19 208s-41.3 7.27-48.56 8.72-8.3 9.54-8.72 12.24 9.34 7.89 22.83 4.57 34-16.4 36.11-17.43 7.68-2.08 11-2.91 6.43-4.15 7.68-4.77 7.68-3.32 11-5.61 3.11-3.94.41-3.73-7.47 2.49-8.92 2.7l-1.46.2 9.76-8.09s3.94-4.56 1.45-4.56-15.15 2.9-17.85 4.77-14.73 13.9-14.73 13.9z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.06 189.77s1.82.48.48 2.3-10.92 9.34-10.92 9.34",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.89 198.5s5.94-3.52 8.25-4.73 10.8-3.52 10.07-1.94-4.86 4.61-4.86 4.61",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49 204.93s7.89-7.06 10.58-8.09 8.93-5.19 8.1-2.91-9.76 8.51-9.76 8.51a24.81 24.81 0 01-3.32 5.19c-1.86 2.07-6.22 4.15-7.05 4.36",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default "/_next/static/media/Digital-lifestyle-bro.534b9b163e23ed8ee4ea2e3b737e6e9a.svg";
export { SvgDigitalLifestyleBro as ReactComponent };